// Path the cabinet is served under on its host, e.g. '/claims/'. This is NOT where
// its files come from: on a CDN deploy Vite's `base` is the CDN URL. Unset means
// the legacy root deploy.
export const APP_ROUTER_BASE = import.meta.env.VITE_ROUTER_BASE || '/';
